import _extends from "@babel/runtime/helpers/extends";
import React, { useContext, forwardRef } from 'react';
import { JssContext } from 'react-jss';
import { globalJss, globalSheetsRegistry, createGenerateId, ThemeProviderContext, JssThemeProvider } from './jss';
import baseTheme from './base';
var generateId = createGenerateId();
var managers = {};
var globalJssContext = {
  generateId: generateId,
  managers: managers,
  jss: globalJss,
  registry: globalSheetsRegistry
};

var getBaseTheme = function getBaseTheme() {
  return baseTheme;
};

export default function withBaseTheme(Component) {
  var WithThemeProvider = forwardRef(function WithThemeProvider(props, ref) {
    var themeContext = useContext(ThemeProviderContext);
    if (themeContext.jss) return React.createElement(Component, _extends({
      ref: ref
    }, props));
    return React.createElement(JssContext.Provider, {
      value: globalJssContext
    }, React.createElement(JssThemeProvider, {
      theme: getBaseTheme
    }, React.createElement(Component, _extends({
      ref: ref
    }, props))));
  });
  return WithThemeProvider;
}